import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';
import type { PositionedItem } from '../PageConfigProvider/types/item';
import { SegmentedToggle } from './SegmentedToggle';

type ArrowDirectionSelectorProps = {
  item: PositionedItem;
  isDisabled?: boolean;
};

export const ArrowDirectionSelector = ({
  item,
  isDisabled = false,
}: ArrowDirectionSelectorProps) => {
  const { dispatch } = useTabContentConfig();
  const id = item?.id;
  const arrowOrientation =
    item?.plot?.divergingBar?.arrowOrientation ?? 'horizontal';

  const handleArrowOrientationChange = (
    newOrientation: 'horizontal' | 'vertical'
  ) => {
    if (id && arrowOrientation !== newOrientation) {
      dispatch({
        type: 'UPDATE_ITEM_DIVERGING_BAR',
        payload: {
          id,
          divergingBar: {
            ...item?.plot?.divergingBar,
            arrowOrientation: newOrientation,
          },
        },
      });
    }
  };

  return (
    <SegmentedToggle
      options={[
        { value: 'horizontal', label: 'Horizontal' },
        { value: 'vertical', label: 'Vertical' },
      ]}
      value={arrowOrientation}
      onChange={handleArrowOrientationChange}
      isDisabled={isDisabled}
    />
  );
};
